import { CatHeading } from '@blocks-react/components/Heading';
import { SystemAndComponentNameDescriptionProps } from '../../types';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import styles from '../../PartsDiagram.module.scss';
import cx from 'classnames';

export const SystemAndComponentNameDescription = ({
  partsName,
  handleClick
}: SystemAndComponentNameDescriptionProps) => {
  return (
    <>
      <div className={cx(styles['system-component-name'])}>
        <CatHeading slot="trigger" variant="body" onClick={handleClick}>
          <span className="text-truncate d-block m-0">{partsName}</span>
        </CatHeading>
      </div>
      <CatIconChevronRight className="px-3" onClick={handleClick} />
    </>
  );
};
